<nav class="navbar navbar-expand navbar-light bg-light capitan-sub-nav pl-md-5">
<ul class="navbar-nav">
  <li class="nav-item">
    <a routerLink="./scheduled" routerLinkActive="active" class="nav-link" href="#">Scheduled Events</a>
  </li>
  <li class="nav-item">
    <a routerLink="./setup" routerLinkActive="active" class="nav-link" href="#">Event Setup</a>
  </li>
  <li class="nav-item">
    <a routerLink="./settings" routerLinkActive="active" class="nav-link" href="#">Event Settings</a>
  </li>
</ul>
</nav>

<router-outlet></router-outlet>
